import React from 'react';
import { Card, CardContent } from '../components/ui/card';

function AboutPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-orange-50 py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-center mb-12 text-slate-800">About Crescent Traders</h1>
          
          <Card className="mb-8">
            <CardContent className="p-8">
              <h2 className="text-2xl font-semibold mb-4 text-orange-600">Our Story</h2>
              <p className="text-slate-700 mb-4">
                Founded with a vision to provide exceptional quality products and services, Crescent Traders has been a trusted name in the industry for years. We believe in building lasting relationships with our clients through reliability, integrity, and excellence.
              </p>
              <p className="text-slate-700">
                Our commitment to quality and customer satisfaction has made us a preferred partner for businesses and individuals alike. We continue to evolve and adapt to meet the changing needs of our customers while maintaining our core values.
              </p>
            </CardContent>
          </Card>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <Card>
              <CardContent className="p-8">
                <h3 className="text-xl font-semibold mb-4 text-orange-600">Our Mission</h3>
                <p className="text-slate-700">
                  To provide our customers with the highest quality products and exceptional service, while building lasting partnerships based on trust, reliability, and mutual success.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-8">
                <h3 className="text-xl font-semibold mb-4 text-orange-600">Our Vision</h3>
                <p className="text-slate-700">
                  To be the leading provider of quality products in our industry, recognized for our commitment to excellence, innovation, and customer satisfaction.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;